/**
 * Mensleesbare labels voor catalogus-ids (UI) — voorkomt " — —" en ruwe slugs in dropdowns/resultaat.
 */

export function titleCaseFromSlug(id: string): string {
  if (!id) return '';
  return id
    .split('_')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

/** Bouwdeel-optie in select: geen dubbele em-dash als eenheid ontbreekt. */
export function formatSystemOptionLabel(system_id: string, label: string | undefined, unit: string | undefined): string {
  const u = (unit ?? '').trim();
  const unitDisplay =
    !u || u === '—' || u === '-' || u === '–'
      ? ''
      : u === 'm2'
        ? 'm²'
        : u === 'm3'
          ? 'm³'
          : u === 'm1'
            ? 'm'
            : u;
  const base = (label ?? '').trim() || titleCaseFromSlug(system_id);
  return unitDisplay ? `${base} — ${unitDisplay}` : base;
}

/** Variant-optie: altijd leesbare fallback op id. */
export function formatVariantOptionLabel(variant_id: string, label: string | undefined): string {
  const l = (label ?? '').trim();
  return l || titleCaseFromSlug(variant_id);
}

/** Toon aggregatie-labels leesbaar als het op een technische slug lijkt. */
export function humanizeAggregateLabel(text: string): string {
  const t = (text ?? '').trim();
  if (!t) return '—';
  if (/^[a-z0-9_]+$/i.test(t) && t.includes('_')) return titleCaseFromSlug(t);
  return t;
}

/** Prijsregel-type uit engine/API → vaste NL-label (geen capitalize('labor') → "Labor"). */
export function pricingLineTypeNl(type: string | undefined | null): string {
  const k = (type ?? '').trim().toLowerCase();
  if (k === 'material' || k === 'materials') return 'Materiaal';
  if (k === 'labor' || k === 'arbeid') return 'Arbeid';
  if (k === 'equipment' || k === 'materieel') return 'Materieel';
  if (!k) return '—';
  return titleCaseFromSlug(k);
}

/** Sleutels uit offerte-samenvatting (breakdown) → NL-label. */
export function quoteBreakdownKeyNl(key: string): string {
  const k = (key ?? '').trim().toLowerCase().replace(/\s+/g, '_');
  if (k.includes('material')) return 'Materialen';
  if (k.includes('labor') || k.includes('labour') || k === 'arbeid') return 'Arbeid';
  if (k.includes('equip') || k.includes('materieel')) return 'Materieel';
  if (k.includes('practical') && k.includes('correct')) return 'Praktische correctie';
  return humanizeAggregateLabel(key);
}
